<template>
  <modal class="alertsPopup" name="AlertsPopup" transition="pop-out" :adaptive="true" @before-open="beforeOpen">
    <div class="thanksPopup fancybox-content" id="noFlightsFoundPopup">
      <div class="thanksPopup__decor"></div>
      <div class="thanksPopup__inner">
        <div class="thanksPopup__title">{{title}}</div>
        <div class="thanksPopup__text">{{text}}</div>
        <router-link to="manually-request" class="thanksPopup__button thanksPopup__button--close">
          <span class="text">Request Flight</span>
        </router-link>
      </div>
      <button class="fancybox-button fancybox-close-small" @click="$modal.hide('AlertsPopup')">
        <SvgIcon name="close-white"/>
      </button>
    </div>
  </modal>
</template>

<script>
  import SvgIcon from '@/components/common/SvgIcon/SvgIcon'
  import './AlertsPopup.styl'

  export default {
    name: 'AlertsPopup',
    data: () => ({
      title: null,
      text: null,
    }),
    methods: {
      beforeOpen (event) {
        this.title = event.params.title
        this.text = event.params.text
      },
    },
    components: {
      SvgIcon,
    },
  }
</script>
